import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchApprovedCallerAddresses = async ({
  callerId,
  pagination = { offset: 0, limit: 100 },
}: {
  callerId: string;
  pagination?: { offset: number; limit: number };
}) => {
  const response = await queryExecute({
    query: graphql(`
      query ApprovedCallerAddresses($callerId: String!, $pagination: PaginationInputType) {
        callerAddresses(callerId: $callerId, pagination: $pagination, isApproved: true) {
          count
          rows {
            id
            name
            streetAddress
            streetAddress2
            city
            state
            zip
            country
            latitude
            longitude
            googlePlaceId
            order
            noteToDriver
            gourmetNoteToDriver
            coordinatesChanges
            phoneNumber
            createdAt
            isAirport
            isApproved
          }
        }
      }
    `),
    variables: {
      callerId,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.callerAddresses;
};
